import { Table, Row, Col } from "react-bootstrap";
import { API_URL } from "../App";
import { UserDataContext } from "../components/UserDataContext";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import "../components/button.css";
import Button from "@mui/material/Button";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import { Modal } from "react-bootstrap";
import Alerts from "../components/Alerts";
import { TaskContext } from "../components/TaskContext";
import AddIcon from "@mui/icons-material/Add";
import Dropzone from "react-dropzone";
import { apiRequest } from "../components/Config";

export default function FilesData() {
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [text, setText] = useState("Pobieranie danych...");
  const [show, setShow] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileId, setFileId] = useState("");
  const [fileDescription, setFileDescription] = useState();
  const [selectedOption, setSelectedOption] = useState("");
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);
  const { taskId } = useContext(TaskContext);
  const [showAddFile, setShowAddFile] = useState(false);
  const [status, setStatus] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      if (!userData) return;
      try {
        const response = await apiRequest(`filestaskId/${taskId}`, "GET");
        setData(response);
        setStatus(response.status);
        if (!response || response.length === 0) {
          setText("Brak danych");
        } else {
          setText("");
        }
      } catch (error) {
        setError(error.message);
      }
    };
    let interval;
    if (userData && userData.userId && taskId > 0) {
      fetchData();
      interval = setInterval(fetchData, 2000);
    }
    return () => clearInterval(interval);
  }, [userData, taskId]);

  const onDrop = (acceptedFiles) => {
    const formData = new FormData();
    acceptedFiles.forEach((file) => {
      formData.append("file", file);
      formData.append("uuid", taskId);
    });

    axios
      .post(`${API_URL}/uploadId`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
      })
      .then((response) => {
        if (response.data.fileId > 0) {
          setApiResponse({
            title: "Informacja",
            severity: "success",
            info: "Plik został poprawnie załadowany.",
          });
          setShowApiResponse(true);
        } else {
          setApiResponse({
            title: "Informacja",
            severity: "warning",
            info: "Wystąpił błąd podczas importu pliku.",
          });
          setShowApiResponse(true);
        }
      })
      .catch((error) => {
        console.error("Błąd: ", error);
      });
  };

  /* obsługa modala */
  /*
  const handleShowFile = (filename, fileoriginal, id, description, shared) => {
    setFileUrl(`${API_URL}/download?file=${filename}`);
    setFileName(fileoriginal);
    setFileId(id);
    setFileDescription(description);
    //setFileShared(shared);
    setSelectedOption(shared);
    setShow(true);
  };
*/
  const handleShowFile = (filename, fileoriginal, id, description, shared) => {
    const fileExt = filename.split(".").pop().toLowerCase();
    const fullUrl = `${API_URL}/download?file=${filename}`;

    // Podgląd tylko dla PDF, reszta: pobranie w nowym oknie
    if (fileExt === "pdf") {
      setFileUrl(fullUrl);
      setFileName(fileoriginal);
      setFileId(id);
      setFileDescription(description);
      setSelectedOption(shared);
      setShow(true);
    } else {
      window.open(fullUrl, "_blank"); // otwiera w nowej karcie
    }
  };
  const handleShowAddFile = () => {
    setShowAddFile(!showAddFile);
  };
  const handleDeleteFile = async (id) => {
    try {
      const response = await apiRequest("delete-file", "POST", { id: id });
      if (response.success) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Plik usunięty",
          severity: "warning",
          info: "Plik został usunięty z serwera!",
        });
      }
      handleClose();
    } catch (error) {
      console.error("Błąd podczas usuwania pliku:", error);
      setShowApiResponse(true);
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Nie udało się usunąć pliku.",
      });
    } finally {
      //setSubmitting(false);
    }
  };

  const handleDescriptionChange = (event) => {
    setFileDescription(event.target.value);
  };

  const handleSaveDescription = async () => {
    try {
      await apiRequest("updatefiledescription", "POST", {
        id: fileId,
        description: fileDescription,
      });
    } catch (error) {
      console.error("Błąd po stronie serwera:", error);
    }
    handleClose();
  };

  const handleClose = () => {
    setShow(false);
    setFileUrl("");
    setFileName("");
    setFileId("");
  };
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Modal show={show} onHide={handleClose} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Podgląd pliku: {fileName}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {fileUrl ? (
              <iframe src={fileUrl} width="100%" height="500px" />
            ) : (
              <p>Nie udało się załadować pliku.</p>
            )}
          </Modal.Body>

          <div className="modal-body">
            {userData &&
              (userData.permId === "1" || userData.permId === "3") &&
              status !== "8" && (
                <Col md="2">
                  <Button
                    variant="contained"
                    color="warning"
                    onClick={() => handleDeleteFile(fileId)}
                  >
                    Usuń plik nieodwracalnie
                  </Button>
                </Col>
              )}
            <form>
              <div className="form-group">
                <label htmlFor="message-text" className="col-form-label">
                  Opis pliku:
                </label>
                <textarea
                  className="form-control"
                  id="message-text"
                  value={fileDescription}
                  onChange={handleDescriptionChange}
                ></textarea>
              </div>
            </form>
          </div>
          <Modal.Footer>
            {userData &&
              (userData.permId === "1" || userData.permId === "3") &&
              status !== "8" && (
                <Col md="4">
                  <Button variant="outlined" onClick={handleSaveDescription}>
                    Zapisz zmiany
                  </Button>
                </Col>
              )}
            <Col md="4">
              <Button variant="outlined" onClick={handleClose}>
                Zamknij
              </Button>
            </Col>
          </Modal.Footer>
        </Modal>
      </ThemeProvider>

      {showApiResponse && (
        <Row>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <div className="table-responsive">
        <Table bordered hover>
          <thead>
            <tr>
              <th className="td-centered">ID</th>
              <th className="td-centered">Plik</th>
              <th className="td-centered">Data utworzenia</th>
              <th className="td-centered">Dodał</th>
              <th className="td-centered">Opis</th>
            </tr>
          </thead>
          {data && data.length > 0 && userData && userData.userId ? (
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td className="td-centered">
                    {(currentPage - 1) * itemsPerPage + index + 1}
                  </td>
                  <td>
                    <AttachFileIcon
                      onClick={() =>
                        handleShowFile(
                          item.filename,
                          item.fileoriginal,
                          item.id,
                          item.description
                        )
                      }
                      style={{ cursor: "pointer", marginRight: "5px" }}
                    />
                    {item.fileoriginal}
                  </td>
                  <td>{item.created}</td>
                  <td className="td-centered">{item.fullName}</td>
                  <td className="td-centered">{item.description}</td>
                </tr>
              ))}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  <p className="p6">{text}</p>
                </td>
              </tr>
            </tbody>
          )}
        </Table>
      </div>
      {userData && status !== "8" && (
        <Button onClick={handleShowAddFile}>
          Dodaj plik
          <AddIcon />
        </Button>
      )}
      {showAddFile && (
        <Dropzone onDrop={onDrop} multiple={false}>
          {({ getRootProps, getInputProps }) => (
            <div
              {...getRootProps()}
              style={{
                border: "2px dashed #8fbc8f",
                padding: "30px",
                cursor: "pointer",
              }}
            >
              <input {...getInputProps()} />
              <p className="p1">
                Przeciągnij i upuść POJEDYNCZY plik tutaj lub kliknij, aby
                wybrać plik z dysku.
              </p>
            </div>
          )}
        </Dropzone>
      )}
    </div>
  );
}
